<div class="flex-container">
  <div class="flex-item detail-grid">
    @if (!isEditingFileNumber) {
      <div class="detail-row">
        <span class="label" data-testid="base-order-reference-number-text">{{ 'orders.referenceNumber' | transloco }}</span>
        <span class="value value-with-action">
          <span>{{ order.referenceNumber }}</span>
          @if (orderIsInDraft()) {
            <button mat-icon-button color="primary" (click)="editReferenceNumber()" [attr.aria-label]="'orders.editReferenceNumber' | transloco"
              data-testid="base-order-edit-reference-button">
              <mat-icon>edit</mat-icon>
            </button>
          }
        </span>
      </div>
    } @else {
      <div class="detail-row-full">
        <mat-form-field class="form-field" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ 'common.labels.referenceNumber' | transloco }}</mat-label>
          <input matInput [(ngModel)]="order.referenceNumber" (keyup.enter)="saveReferenceNumber()" [placeholder]="'common.labels.referenceNumber' | transloco"
            data-testid="base-order-reference-number-field">
        </mat-form-field>
        <button mat-icon-button color="primary" (click)="saveReferenceNumber()" [attr.aria-label]="'orders.saveReferenceNumber' | transloco"
          data-testid="base-order-save-reference-button">
          <mat-icon>save</mat-icon>
        </button>
      </div>
    }
    <div class="detail-row">
      <span class="label">{{ 'orders.orderType' | transloco }}</span>
      <span class="value" data-testid="base-order-type-text">{{ order.orderTypeID | enumLabel:'orderType':order.orderType.name }}</span>
    </div>
    <div class="detail-row">
      <span class="label">{{ 'orders.orderStatus' | transloco }}</span>
      <span class="value" data-testid="base-order-status-text">{{ order.orderStatusTypeID | enumLabel:'orderStatusType' }}</span>
    </div>
  </div>

  <div class="flex-item detail-grid">
    <div class="detail-row">
      <span class="label">{{ 'orders.requestedBy' | transloco }}</span>
      <span class="value" data-testid="base-order-requested-by-text">{{ requestingUser }}</span>
    </div>
    @if (_hasMultipleUserGroups) {
      <div class="detail-row">
        <span class="label">{{ 'orders.requestedFor' | transloco }}</span>
        <span class="value" data-testid="base-order-requested-by-text">{{ requestingUserGroup }}</span>
      </div>
    }
    <div class="detail-row">
      <span class="label">{{ 'orders.country' | transloco }}</span>
      <span class="value" data-testid="base-order-country-text">{{ order.country }}</span>
    </div>
    <div class="detail-row">
      <span class="label">{{ 'orders.jurisdiction' | transloco }}</span>
      <span class="value" data-testid="base-order-jurisdiction-text">{{ order.jurisdiction | jurisdictionLabel:order.country:order.displayJurisdiction }}</span>
    </div>
    @if (showQcForm(order)) {
      <div class="detail-row">
        <span class="label">{{ 'orders.formType' | transloco }}</span>
        <span class="value" data-testid="base-order-qc-form-text">{{ order.lien!.qcFormTypeID! }}</span>
      </div>
    }
  </div>
</div>